import {
    createSimplePrivateGalleryWithAjaxSource,
} from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';

export default function initializeSimpleGalleries() {
    $('.simpleGallery').toArray().forEach((element) => {
        const $galleryContainer = $(element);

        createSimplePrivateGalleryWithAjaxSource($.get, {
            source: $galleryContainer.data('simplegalleryurl'),
            queryParameters: {
                unitids: $galleryContainer.data('unitids'),
                imagesize: getRecommendedImageSize(),
            },
            nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
            previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
            counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
            imageElement: $galleryContainer.find('.searchImg')[0],
        });
    });
}

function getRecommendedImageSize() {
    return 'medium';
}
